import { QueryKeys } from 'constants/queries'
import { GetCourseByIdResponse, GetCoursesResponse } from 'models/lectures/ApiModels/lectures'
import { http } from 'services/http'

type QueryParams = {
  id: number
}

export const getCourses = (): Promise<GetCoursesResponse> => {
  return http.get<GetCoursesResponse, GetCoursesResponse>(`/courses`)
}

export const getCourseById = ({ queryKey: [, { id }] }: { queryKey: [QueryKeys, QueryParams] }): Promise<GetCourseByIdResponse> =>
  http.get<GetCourseByIdResponse, GetCourseByIdResponse>(`/courses/${id}`)
